
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/casestudy/hul",
      function () {
        return require("private-next-pages/casestudy/hul.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/casestudy/hul"])
      });
    }
  